import { Injectable } from '@angular/core';
import { NodeService } from './node.service';

export interface ObserverRelaySnapshot {
    urls: string[];
    activeMatchup: string | null;
}

/** The Electron main process owns the relay across renderer reloads. */
@Injectable({ providedIn: 'root' })
export class ObserverRelayService {
    private startPromise: Promise<ObserverRelaySnapshot> | null = null;

    constructor(private readonly node: NodeService) { }

    ensure(): Promise<ObserverRelaySnapshot> {
        this.startPromise ??= this.start().catch(error => {
            this.startPromise = null;
            throw error;
        });
        return this.startPromise;
    }

    private async start(): Promise<ObserverRelaySnapshot> {
        if (!this.node.isAvailable()) return { urls: [], activeMatchup: null };
        const snapshot = await this.node.ipcRenderer.invoke('observer-relay:ensure');
        if (!snapshot || !Array.isArray(snapshot.urls) ||
            !snapshot.urls.every(url => typeof url === 'string') ||
            !(snapshot.activeMatchup === null || typeof snapshot.activeMatchup === 'string')) {
            throw new Error('Invalid main-process relay response.');
        }
        return snapshot;
    }
}
